import { productIdFormat } from "@redotech/redo-product-id";
import {
  SuppliesTrackableProductSchema,
  SuppliesTrackableProductTypeSchema,
} from "@redotech/redo-supplies-common/trackable-product";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/**
 * Bulk-marks supplies products as trackable. A product is trackable at most
 * once, so a product already on the list fails the whole call.
 */
export const createTrackableProducts = unaryRpc({
  name: "createTrackableProducts" as const,
  input: z.object({
    trackableProducts: z
      .array(
        z.object({
          suppliesProductId: productIdFormat.schema,
          type: SuppliesTrackableProductTypeSchema,
          quantityPerCase: z.number().int().positive(),
        }),
      )
      .min(1),
  }),
  output: z.object({
    trackableProducts: z.array(SuppliesTrackableProductSchema),
  }),
});
